import React from 'react';

import './SeasonSelect.scss';

import { ISeason } from '../../utils/models';
export interface ISeasonSelectProps {
  value: number;
  options: ISeason[];
  onSelect: (index: number) => void;
  className?: string;
}

const SeasonSelect = ({
  value,
  options,
  onSelect,
  className = '',
}: ISeasonSelectProps) => {
  return (
    <div className={`season-select ${className}`}>
      <span
        className="season-select__selected"
        style={{ pointerEvents: 'none' }}
        aria-hidden={true}
      >
        {options[value].name}
      </span>
      <span className="season-select__arrows" />

      <select
        className={`season-select__input `}
        name="seasonSelect"
        id="season-select"
        onChange={e => onSelect(+e.target.value)}
        value={value}
        aria-label="Select a Season"
      >
        {options.map(({ name }, i) => (
          <option key={name} value={i}>
            {name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SeasonSelect;
